/* RevitaPaw PDP — Playful Bold, compact purchase flow (2026-07-28).
   Preserves hooks: #atc-btn[data-variant-id], REVITAPAW_VARIANTS,
   REVITAPAW_SELLING_PLANS, addToCart, selectBundle, setSize, toggleSub,
   setImg, buyAcc, toggleFaq(shared), setFreq. ATC opens the cart drawer. */
(function(){window.RP_PDP=true})();
var RP_R=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── PRICING — driven entirely by real variant data rendered via Liquid.
   Each .bundle-opt carries data-variant-id + data-price (cents) from
   product.variants. No hardcoded prices anywhere. ── */
var BUNDLES=Array.prototype.map.call(document.querySelectorAll('#bundleOpts .bundle-opt'),function(el,i){
  return {variantId:Number(el.dataset.variantId),price:Number(el.dataset.price),tubs:Number(el.dataset.tubs||i+1),subPrice:el.dataset.subPrice?Number(el.dataset.subPrice):null};
});
/* default bundle: read from the Liquid-rendered .on card so the section's
   default_bundle assign is the SINGLE SOURCE (P0 §6 — swap there for A/B) */
var currentBundle=(function(){
  var cards=document.querySelectorAll('#bundleOpts .bundle-opt');
  for(var i=0;i<cards.length;i++)if(cards[i].classList.contains('on'))return i;
  return 1;
})();
var currentSize=-1;            /* P0 §5: NO default size — dosing UI only, optional */
var subOn=false;window.subOn=false;
var currentPlanId=(window.REVITAPAW_SELLING_PLANS||[])[0]?window.REVITAPAW_SELLING_PLANS[0].id:null;
var SUB_PCT=(function(){
  var t=document.getElementById('subToggle');
  var v=t?parseFloat(t.dataset.subPct):10;
  return isFinite(v)?v:10;
})();
/* STACKING (2026-07-30 order — supersedes P0 §4 either/or): WELCOME10 applies
   ON TOP of the subscription discount — CHECKOUT-VERIFIED (2-Tub sub $70.20 −
   WELCOME10 $7.02 = $63.18 total; code hits the FIRST order, renewals bill the
   plan price). If admin changes Discounts → WELCOME10 → Combinations, flip
   RP_STACKS to false (the WELCOME10 preview line hides in subscribe mode).
   NOTE 2026-08-04: RP_STACKS affects ONLY the welcome preview line — the
   card "Save" badges never include WELCOME10 (double-count fix). */
var RP_STACKS=true;
var WELCOME_PCT=10; /* WELCOME10 = 10% (admin-confirmed code) */
function stackedFirstOrder(cents){return Math.round(cents*(100-WELCOME_PCT)/100)}

function money(cents){
  var d=cents/100;
  return '$'+(Math.round(d*100)%100===0&&d%1===0?d.toFixed(0):d.toFixed(2)).replace(/\.00$/,'');
}

/* ── SUPPLY (locked matrix): estimated supply lives INSIDE each bundle card
   and reflects the SELECTED SIZE (tubs×100 ÷ chews/day, Customizer values
   on the size pills as data-sup1/2/3). Size never touches price/variant. ── */
function updateSupplies(){
  var pill=document.querySelector('#sizeSeg .size-pill.on');
  for(var i=0;i<3;i++){
    var el=document.getElementById('bSupply'+i);
    if(!el)continue;
    /* no size picked (P0 §5 no-default): show the per-bundle RANGE
       (Liquid-rendered data-range, e.g. "~4–8 weeks") */
    if(!pill){el.textContent=(el.dataset.range||'')+' supply';continue}
    var v=pill.getAttribute('data-sup'+(i+1));
    if(v)el.textContent=v+' supply';
  }
}

/* ── 6 · savings sentence + slim bar — amounts from live BUNDLES prices.
   SINGLE MODEL (2026-08-04 fix): saving = full price at the 1-tub rate MINUS
   the price actually charged — BOTH modes. Never add a percentage on top of
   an already-discounted price (the old subscribe figures double-counted the
   10% by subtracting WELCOME10 off the plan price: $9.31/$34.82/$64.38 —
   correct figures are $4.90/$27.80/$55.20). WELCOME10 stays a separate
   first-order preview line, never folded into "Save". ── */
function bundleSaving(i){
  var b=BUNDLES[i];if(!b)return 0;
  var full=BUNDLES[0].price*b.tubs;
  if(!subOn)return full-b.price;
  var sub=b.subPrice!=null?b.subPrice:Math.round(b.price*(100-SUB_PCT)/100);
  return full-sub;
}
function updateSavings(){
  var line=document.getElementById('svLine'),fill=document.getElementById('svFill');
  if(!line||!fill||BUNDLES.length<3)return;
  var save=[bundleSaving(0),bundleSaving(1),bundleSaving(2)];
  var amt=function(c){return '<b class="sv-amt">'+money(c)+'</b>'};
  if(currentBundle===0){
    if(save[0]>0){line.innerHTML='You’re saving '+amt(save[0])+' — add 1 more tub to save '+amt(save[1]);fill.style.width=Math.round(save[0]/save[2]*100)+'%'}
    else{line.innerHTML='Add 1 more tub to start saving';fill.style.width='0%'}
  }
  else if(currentBundle===1){line.innerHTML='You’re saving '+amt(save[1])+' — add 1 more tub to save '+amt(save[2]);fill.style.width=Math.round(save[1]/save[2]*100)+'%'}
  else{line.innerHTML='Maximum saving unlocked — you save '+amt(save[2]);fill.style.width='100%'}
}

function updatePrice(){
  var b=BUNDLES[currentBundle];
  if(!b)return;
  /* subscribe price from selling_plan_allocations (real cents), never computed */
  var subPrice=b.subPrice!=null?b.subPrice:Math.round(b.price*(100-SUB_PCT)/100);
  var displayed=subOn?subPrice:b.price;
  var label=(subOn?'Subscribe — ':'Add to Cart — ')+money(displayed)+' total'+(subOn?' ('+SUB_PCT+'% off)':'');
  var atc=document.getElementById('atcText');
  if(atc)atc.textContent=label;
  var atcBtn=document.getElementById('atc-btn');
  if(atcBtn)atcBtn.dataset.variantId=b.variantId;
  var atcInput=document.getElementById('atcVariantInput');
  if(atcInput)atcInput.value=b.variantId;
  document.querySelectorAll('.js-atc-label').forEach(function(el){el.textContent=label});
  document.querySelectorAll('.js-price-label').forEach(function(el){el.textContent=money(displayed)});
  document.querySelectorAll('.js-sub-price').forEach(function(el){el.textContent=money(subPrice)});
  /* sticky bar mirrors the FULL selection (P0 §2): bundle · purchase type ·
     size (only once the customer picked one) · savings · live total */
  var sel=document.getElementById('stickySel');
  if(sel){
    var sizePill=document.querySelector('#sizeSeg .size-pill.on');
    sel.textContent=b.tubs+' Tub'+(b.tubs>1?'s':'')+' · '+(subOn?'Subscribe':'One-time')+(sizePill?' · '+sizePill.dataset.name:'');
  }
  var sv=document.getElementById('stickySave');
  if(sv){
    var fullPrice=(BUNDLES[0]?BUNDLES[0].price:4900)*b.tubs;
    var savings=fullPrice-displayed;
    if(savings>0){sv.textContent='You save '+money(savings)}
    else{sv.textContent='30-day money-back · Free US shipping'}
  }
  /* PER-CARD re-render (2026-07-30): every card's total / SAVE badge / unit
     math follows the mode — all from REAL cents (variant price + selling-plan
     allocation); savings = full @ 1-tub rate − charged (both modes, no
     WELCOME10 term — 2026-08-04 double-count fix). */
  BUNDLES.forEach(function(bb,i){
    var sub=bb.subPrice!=null?bb.subPrice:Math.round(bb.price*(100-SUB_PCT)/100);
    var shown=subOn?sub:bb.price;
    var t=document.getElementById('bTotal'+i);if(t)t.textContent=money(shown);
    var p=document.getElementById('bPer'+i);if(p)p.textContent=money(Math.round(shown/bb.tubs))+'/tub';
    var c=document.getElementById('bChew'+i);if(c)c.textContent=money(Math.round(shown/(bb.tubs*100)))+'/chew';
    var sv=document.getElementById('bSave'+i);
    if(sv){
      var saveC=bundleSaving(i);
      if(saveC>0){sv.textContent='Save '+money(saveC);sv.classList.remove('bo-save-none')}
      else{sv.textContent='100 chews';sv.classList.add('bo-save-none')}
    }
  });
  /* WELCOME10 preview line — STACKS (2026-07-30, checkout-verified): shown in
     BOTH modes; in subscribe mode it's the FIRST-ORDER total (renewals bill
     the plan price, already shown on the ATC + sub-note). */
  var wl=document.getElementById('welcomeLine');
  if(wl){
    if(RP_STACKS){
      wl.hidden=false;
      wl.innerHTML='<b class="js-welcome-price">'+money(stackedFirstOrder(displayed))+'</b> '+(subOn?'first order with WELCOME10':'with WELCOME10')+' · Free shipping';
    }else{
      wl.hidden=subOn;
      if(!subOn)wl.innerHTML='<b class="js-welcome-price">'+money(stackedFirstOrder(displayed))+'</b> with WELCOME10 · Free shipping';
    }
  }
  /* (quickadd sync loop DELETED with P0 §1 — no /cart/add CTA exists outside
     the module form + sticky bar; in-content CTAs are anchor links) */
  var st=document.getElementById('selStatus');
  if(st)st.textContent=b.tubs+' Tub'+(b.tubs>1?'s':'')+(subOn?', subscription':', one-time')+' — '+money(displayed)+' total';
  updateSavings();
}

/* ── 5 · SIZE — dosing UI ONLY (locked): updates the status line + per-card
   supplies, NEVER the selected variant or any price. Remembered per session. ── */
function setSize(btn,idx){
  currentSize=idx;
  var seg=document.getElementById('sizeSeg');
  if(seg)seg.querySelectorAll('.size-pill').forEach(function(b){b.classList.remove('on');b.setAttribute('aria-checked','false')});
  if(btn){
    btn.classList.add('on');
    btn.setAttribute('aria-checked','true');
    var st=document.getElementById('sizeDose');
    if(st)st.innerHTML=(btn.dataset.name||'')+' dog · <b>'+(btn.dataset.dose||'')+'</b>';
  }
  try{sessionStorage.setItem('rp_size',String(idx))}catch(e){}
  updateSupplies();
  updatePrice(); /* sticky-bar mirror only — price/variant provably unchanged by size */
}

/* ── BUY-BOX ACCORDIONS ── */
function buyAcc(btn){
  var open=btn.getAttribute('aria-expanded')==='true';
  btn.setAttribute('aria-expanded',String(!open));
  btn.parentNode.classList.toggle('open',!open);
}

/* ── 7 · BUNDLE — cards are labels around REAL radio inputs (P0 a11y): the
   input carries state/keyboard/focus; .on drives the visuals. Programmatic
   calls (deep links) sync the input too. ── */
function selectBundle(el,idx){
  document.querySelectorAll('.bundle-opt').forEach(function(b){b.classList.remove('on')});
  if(el){
    el.classList.add('on');
    var inp=el.querySelector('.bo-input');
    if(inp&&!inp.checked)inp.checked=true;
  }
  /* variant featured media (2026-07-30): switch the gallery ONLY when the new
     variant's OWN media differs from the current variant's — shared or absent
     variant media (the normal bundle case) leaves the gallery where it is */
  var vs=window.REVITAPAW_VARIANTS||[];
  var om=vs[currentBundle]?vs[currentBundle].mediaIdx:-1;
  var nm=vs[idx]?vs[idx].mediaIdx:-1;
  currentBundle=idx;
  if(typeof nm==='number'&&nm>-1&&nm!==om)setImg(nm);
  updatePrice();
  updateSupplies();
}

/* ── 8 · ONE-TIME / SUBSCRIBE — real selling-plan integration ── */
function toggleSub(){
  subOn=!subOn;window.subOn=subOn;
  var body=document.getElementById('subBody');
  if(body)body.classList.toggle('open',subOn);
  var one=document.getElementById('ptOne'),sub=document.getElementById('ptSub');
  if(one){one.classList.toggle('on',!subOn);one.setAttribute('aria-checked',String(!subOn))}
  if(sub){sub.classList.toggle('on',subOn);sub.setAttribute('aria-checked',String(subOn))}
  updatePrice();
}
function setFreq(planId){
  currentPlanId=Number(planId);
  /* P0 §3 disclosure: "Renews every N weeks" follows the real selected plan */
  var sel=document.getElementById('freqSelect'),w=document.getElementById('subFreqWord');
  if(sel&&w){
    /* find by VALUE (programmatic calls may not have moved selectedIndex) */
    var opt=null;
    for(var i=0;i<sel.options.length;i++)if(Number(sel.options[i].value)===currentPlanId){opt=sel.options[i];break}
    if(opt){
      var t=opt.textContent.replace(/\s*\(recommended\)\s*/i,'').trim();
      w.textContent=/^every/i.test(t)?t:t.replace(/^Deliver(y)?\s+/i,'');
    }
  }
}

/* ── 9 · ADD TO CART → drawer. Adds EXACTLY the selected bundle's variant. ── */
var RP_ATC_BUSY=false;
function addToCart(){
  if(RP_ATC_BUSY)return;
  var btn=document.getElementById('atc-btn');
  var status=document.getElementById('atcStatus');
  var orig=btn?btn.innerHTML:'';
  var b=BUNDLES[currentBundle];
  var variantId=b?b.variantId:(btn?Number(btn.dataset.variantId):null);
  if(!variantId)return;
  RP_ATC_BUSY=true;
  window.RP_LAST_ATC=Date.now();
  if(btn){btn.disabled=true;btn.innerHTML='<span>Adding…</span>'}
  var item={id:variantId,quantity:1};
  if(subOn&&currentPlanId)item.selling_plan=currentPlanId;
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[item]})
  }).then(function(r){
    if(!r.ok)throw new Error('add failed');
    if(btn)btn.innerHTML='<span>Added to cart</span>';
    if(status)status.textContent='Added to cart';
    setTimeout(function(){
      if(window.RPCart)window.RPCart.open();
      if(btn){btn.innerHTML=orig;btn.disabled=false;updatePrice()}
      RP_ATC_BUSY=false;
    },450);
  }).catch(function(){
    if(status)status.textContent='Could not add to cart — taking you to the cart page';
    if(btn){btn.innerHTML=orig;btn.disabled=false}
    RP_ATC_BUSY=false;
    window.location='/cart/add?id='+variantId+'&quantity=1';
  });
}

/* ── 1 · CAROUSEL (scroll-snap) — arrows page it (thumbs + dots removed
   2026-07-30; the .thumb loop below is a no-op guard kept in case thumbs
   ever return) ── */
var carTrack=document.getElementById('carTrack');
var carN=carTrack?carTrack.children.length:0;
var carI=0;
function carSync(i){
  carI=Math.max(0,Math.min(i,carN-1));
  var strip=document.getElementById('thumbStrip');
  document.querySelectorAll('.thumb').forEach(function(t,j){
    var on=j===carI;
    t.classList.toggle('active',on);
    t.setAttribute('aria-selected',on?'true':'false');
    if(on&&strip){
      var tl=t.offsetLeft,tr=tl+t.offsetWidth;
      if(tl<strip.scrollLeft)strip.scrollLeft=tl-8;
      else if(tr>strip.scrollLeft+strip.clientWidth)strip.scrollLeft=tr-strip.clientWidth+8;
    }
  });
}
function setImg(i,el){
  if(!carTrack)return;
  var slide=carTrack.children[i];
  if(slide)carTrack.scrollTo({left:slide.offsetLeft,behavior:RP_R?'auto':'smooth'});
  carSync(i);
}
function carGo(dir){setImg(carI+dir)}
if(carTrack){
  var carTO;
  carTrack.addEventListener('scroll',function(){
    clearTimeout(carTO);
    carTO=setTimeout(function(){
      var w=carTrack.clientWidth||1;
      carSync(Math.round(carTrack.scrollLeft/w));
    },80);
  },{passive:true});
  /* initial slide = the selected variant's featured media (Liquid-computed
     data-init-idx); instant jump — never animate at load */
  var carInit=Number(carTrack.dataset.initIdx||0);
  if(carInit>0&&carTrack.children[carInit]){
    carTrack.scrollLeft=carTrack.children[carInit].offsetLeft;
    carSync(carInit);
  }
}

/* ── 11 · STICKY BAR — hidden while the buy box CTA is on screen, while the
   footer wordmark is visible, and while ANY inline .cta-watch CTA shows ── */
var RP_WORD_VIS=false;
(function(){
  var w=document.querySelector('.foot-wordrow');
  if(w&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){RP_WORD_VIS=e.isIntersecting});
    },{threshold:.15}).observe(w);
  }
})();
var RP_CTA_SEEN=(function(){
  var s=new Set();
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){e.isIntersecting?s.add(e.target):s.delete(e.target)});
    },{threshold:.4});
    document.querySelectorAll('.cta-watch').forEach(function(el){io.observe(el)});
  }
  return s;
})();
window.addEventListener('scroll',function(){
  var atc=document.getElementById('atc-btn'),bar=document.getElementById('stickyBar');
  if(atc&&bar){
    var r=atc.getBoundingClientRect();
    var show=r.bottom<0&&!RP_WORD_VIS&&RP_CTA_SEEN.size===0;
    bar.classList.toggle('show',show);
    document.body.classList.toggle('rp-bar-shown',show);
  }
},{passive:true});

/* ── BUY-CARD LOAD CHOREOGRAPHY (safe: visible without JS) ── */
(function(){
  if(RP_R)return;
  var ids=['pfTitle','pfRating','pdpDesc']; /* pfUsps removed 2026-08-04 (chip row deleted) */
  var els=ids.map(function(id){return document.getElementById(id)}).filter(Boolean);
  els.forEach(function(el){el.classList.add('pre')});
  window.addEventListener('load',function(){
    els.forEach(function(el,i){setTimeout(function(){el.classList.add('in')},60+i*55)});
  });
  setTimeout(function(){els.forEach(function(el){el.classList.add('in')})},2500);
})();

/* init — default bundle from the rendered markup (single source), NO size
   preselected (P0 §5); a size the customer explicitly chose earlier in the
   session is restored (their choice, not a guess) */
(function(){
  var saved=null;
  try{saved=sessionStorage.getItem('rp_size')}catch(e){}
  if(saved!==null){
    var idx=parseInt(saved,10);
    var pill=document.querySelectorAll('#sizeSeg .size-pill')[idx];
    if(pill&&idx>=0&&idx<=2){setSize(pill,idx)}
  }
})();
setFreq(currentPlanId); /* seed the renewal-frequency disclosure word */
updatePrice();
updateSupplies();

/* deep link: ?sub=1 pre-enables the subscription (final-close / footer
   "Subscribe & save" links land here on a real selling plan) */
if(/[?&]sub=1\b/.test(location.search)&&!subOn&&currentPlanId)toggleSub();

/* Phase 2 (reworked 2026-07-28): whole teaser card opens that review's OWN
   lightbox via the scroller module's public opener — works for photoless
   reviews too (the old strip-thumb routing only covered photo reviews). */
window.tezOpen=function(idx){
  if(window.rpSrvOpen)rpSrvOpen(idx);
};

/* (ingAccT DELETED 2026-07-28 — the PDP ingredient accordion was replaced by
   the shared rp-calmstack snippet; its toggle is window.ingMore in
   rp-shared.js) */

/* homepage bundle-preview deep link (2026-07-28): ?variant=&selling_plan=&size=
   pre-selects the matching bundle / subscribe+frequency / dog size on load.
   No params = normal PDP (2-Tub default). URL wins over the sessionStorage
   size restore (this runs after init). */
(function(){
  try{
    var q=new URLSearchParams(location.search);
    var v=q.get('variant');
    if(v){
      var vi=-1;(window.REVITAPAW_VARIANTS||[]).forEach(function(x,i){if(String(x.id)===String(v))vi=i;});
      if(vi>-1&&vi!==currentBundle){var el=document.getElementById('b'+vi);if(el)selectBundle(el,vi);}
    }
    var sp=q.get('selling_plan');
    if(sp){
      var ok=(window.REVITAPAW_SELLING_PLANS||[]).some(function(pl){return String(pl.id)===String(sp);});
      if(ok){
        var sel=document.getElementById('freqSelect');if(sel)sel.value=sp;
        setFreq(sp);
        if(!window.subOn)toggleSub();
      }
    }
    var sz={small:0,medium:1,large:2}[q.get('size')];
    if(sz!==undefined){var pill=document.querySelectorAll('#sizeSeg .size-pill')[sz];if(pill)setSize(pill,sz);}
  }catch(e){}
})();

/* ── FULL-SIZE LIGHTBOX (2026-07-30) — click/tap/Enter/Space on the gallery
   opens it at the current slide; ‹›/swipe/←→ page it; ✕/backdrop/Esc close.
   Slides hydrate from data-src on FIRST open only (no initial-load cost).
   Focus trapped while open, restored to the gallery on close. ── */
var pzLb=document.getElementById('pzLb'),pzTrack=document.getElementById('pzTrack');
var pzI=0,pzN=pzTrack?pzTrack.children.length:0,pzHydrated=false,pzPrevFocus=null,pzCloseTO=null;
function pzHydrate(){
  if(pzHydrated)return;pzHydrated=true;
  pzTrack.querySelectorAll('img[data-src]').forEach(function(im){im.src=im.dataset.src;im.removeAttribute('data-src')});
}
function pzSet(i,instant){
  pzI=Math.max(0,Math.min(i,pzN-1));
  var s=pzTrack.children[pzI];
  if(s)pzTrack.scrollTo({left:s.offsetLeft,behavior:(instant||RP_R)?'auto':'smooth'});
}
function pzGo(d){pzSet(pzI+d)}
function pzOpen(i){
  if(!pzLb||!pzN)return;
  clearTimeout(pzCloseTO);
  pzHydrate();
  pzPrevFocus=document.activeElement;
  pzLb.hidden=false;
  requestAnimationFrame(function(){pzLb.classList.add('open')});
  document.documentElement.style.overflow='hidden';
  pzSet(typeof i==='number'?i:carI,true);
  var x=document.getElementById('pzX');if(x)x.focus();
}
function pzClose(){
  if(!pzLb||pzLb.hidden)return;
  pzLb.classList.remove('open');
  clearTimeout(pzCloseTO);
  if(RP_R){pzLb.hidden=true}else{pzCloseTO=setTimeout(function(){pzLb.hidden=true},230)}
  document.documentElement.style.overflow='';
  if(pzPrevFocus&&pzPrevFocus.focus)pzPrevFocus.focus();
}
if(pzLb){
  pzLb.addEventListener('click',function(e){
    if(e.target===pzLb||e.target.classList.contains('pz-slide'))pzClose();
  });
  document.addEventListener('keydown',function(e){
    if(pzLb.hidden)return;
    if(e.key==='Escape'){pzClose()}
    else if(e.key==='ArrowLeft'){e.preventDefault();pzGo(-1)}
    else if(e.key==='ArrowRight'){e.preventDefault();pzGo(1)}
    else if(e.key==='Tab'){
      var f=pzLb.querySelectorAll('button');
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    }
  });
  var pzTO;
  pzTrack.addEventListener('scroll',function(){
    clearTimeout(pzTO);
    pzTO=setTimeout(function(){
      var w=pzTrack.clientWidth||1;
      pzI=Math.max(0,Math.min(Math.round(pzTrack.scrollLeft/w),pzN-1));
    },80);
  },{passive:true});
}
if(carTrack&&pzLb){
  /* click opens UNLESS the pointer travelled (that was a swipe) */
  var pzDx=0,pzDy=0;
  carTrack.addEventListener('pointerdown',function(e){pzDx=e.clientX;pzDy=e.clientY},{passive:true});
  carTrack.addEventListener('click',function(e){
    if(Math.abs(e.clientX-pzDx)>8||Math.abs(e.clientY-pzDy)>8)return;
    pzOpen(carI);
  });
  carTrack.addEventListener('keydown',function(e){
    if(e.key==='Enter'||e.key===' '){e.preventDefault();pzOpen(carI)}
  });
}
